import { ICrudRoute, IRoute } from '@interfaces/App.interface';
import { capitalize } from 'lodash';

export const generateCRUDRoutes = (crudEntitiesData: ICrudRoute[] | null, crudEntityData?: ICrudRoute): IRoute[] => {
  const crudRoutes: IRoute[] = [];

  if (crudEntitiesData) {
    for (const entityData of crudEntitiesData) {
      crudRoutes.push(...generateCRUDRoutes(null, entityData));
    }
    return crudRoutes;
  }

  if (crudEntityData) {
    const { entityName, DataTable, FormPage, aclId, customId, customTitle, customEntityName } = crudEntityData;
    const plurals: string = typeof customEntityName === 'string' ? customEntityName : customEntityName?.table ?? `${entityName}s`;

    const routes: IRoute[] = [];

    if (DataTable) {
      routes.push({
        id: typeof customId === 'string' ? customId : customId?.table || plurals,
        matchPath: typeof customEntityName === 'object' ? `${customEntityName.matchPath}` : `/${plurals}`,
        pageComponent: DataTable,
        pageTitle: customTitle?.table ?? capitalize(plurals),
        aclId,
        canFilter: true,
      });
    }

    if (FormPage) {
      routes.push(
        {
          id: typeof customId === 'object' && customId.new ? customId.new : entityName + 'New',
          matchPath: `/${entityName}/new`,
          pageComponent: FormPage.new ?? FormPage,
          pageTitle: customTitle?.new ?? `New ${entityName}`,
          aclId,
        },
        {
          id: typeof customId === 'object' && customId.edit ? customId.edit : entityName + 'Edit',
          matchPath: `/${entityName}/:id/edit`,
          pageComponent: FormPage.edit ?? FormPage,
          pageTitle: customTitle?.edit ?? `Edit ${entityName}`,
          aclId,
        },
        {
          id: typeof customId === 'object' && customId.view ? customId.view : entityName + 'View',
          matchPath: `/${entityName}/:id/view`,
          pageComponent: FormPage.view ?? FormPage,
          pageTitle: customTitle?.view ?? `View ${entityName}`,
          aclId,
        }
      );
    }

    return routes;
  }

  return crudRoutes;
};
